<template>
  <v-snackbar v-model="showCookies" bottom multi-line timeout="-1">
    We use cookies to ensure safety and improve your experience on our website.
    Please review our
    <a href="/legal/#cookie-policy" target="_blank">Cookie Policy</a> for more
    details.
    <template v-slot:action>
      <v-btn color="green" text @click="acceptCookies"> Accept </v-btn>
      <!-- <v-btn color="red" text @click="rejectCookies"> Reject </v-btn> -->
    </template>
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      //   showCookies: !localStorage.getItem("cookie_consent"),
      showCookies: false,
    };
  },
  mounted() {
    // check if cookieConsent is already set in localStorage
    if (this.$store.getters.getCookieConsent) {
      this.showCookies = false;
    } else {
      this.showCookies = true;
    }
  },
  methods: {
    acceptCookies() {
      this.$store.commit("setCookieConsent", true);
      this.showCookies = false;
    },
  },
};
</script>
